import FetchProxy from "./FetchProxy";

/**
 *
 * En las páginas PHP se debe poner algo como esto para que funcione este sistema
 *
 * <?php if ($advancedLogin->getSessionIdUser()!="") { ?>
<script>
    var screenOnSessionExpired = new ScreenOnSessionExpired();
    screenOnSessionExpired.restUrl={!!  json_encode($advancedLogin->controllerUrl) !!};
    screenOnSessionExpired.loginPage={!!  json_encode($advancedLogin->loginPage) !!};
    screenOnSessionExpired.timeBetweenRequests=60000;
    screenOnSessionExpired.initEvents();
</script>
<?php } ?>

 */
export default class ScreenOnSessionExpired {

    /**
     * Url a la que se llama para saber si la sesión está activa o no
     * @type {null}
     */
    restUrl= null;

    loginPage =null;

    sessionExpired=false;

    //timeBetweenRequests = 60000;
    timeBetweenRequests = 1000;

    constructor() {
        this.fetchProxy=new FetchProxy();
    }

    /**
     * Inicializa los eventos del formulario para que caundo se pulse en "guardar" se activen los eventos necesarios
     */
    initEvents() {
        this.log("ScreenOnSessionExpired.initEvents");
        window.setInterval(()=> {
            if (!this.sessionExpired) {
                this.checkSessionExpired();
            }
        },this.timeBetweenRequests)
    }

    async checkSessionExpired() {
        this.log("ScreenOnSessionExpired.checkSessionExpired");
        try {
            //restUrl='https://api.spotify.com/v1/artists/0OdUWJ0sBjDrqHygGUXeCFcdsds';
            let requestPureArray = {"op":"session_check_expired","_token":$("meta[name=csrf-token]").attr("content") };
            let response = await this.fetchProxy.fetchUrlPostUrlEncoded(this.restUrl, requestPureArray);
            let data = await response.json();
            if (data.errorCode=="0") {

            } else if (data.errorCode=="1") {
                //La petición ha sido correcta, pero la sesión ha expirado. Creo una capa con acceso al login
                this.onSessionExpired();
                this.sessionExpired=true;
            }
        } catch (e) {
            this.log(e);
        }
    }

    onSessionExpired() {
        let loginPage=this.loginPage;
        if (Swal!=undefined) {
            Swal.fire({
                title: 'La sesión ha caducado',
                text: "Pulse aceptar para volver a la página de acceso",
                type: 'warning',
                confirmButtonText: 'Aceptar',
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {
                window.location.href=loginPage;
            })
        } else {
            alert("La sesión ha cadcucado. Pulse aceptar para volver a la página de acceso");
            window.location.href=loginPage;
        }
    }

    log(msg) {
        console.log(msg);
    }
}